import { Listicles } from '@components/organisms/Listicles/Listicles';
import { ListicleType } from '@src/lib/graphql/generated';

export default function ContentElementListicle(element, ExtraData) {
  if (element?.items?.length < 1) return;
  return (
    <div>
      <Listicles
        isArticle
        display={element.listicle_style}
        listicle_type={ListicleType.Manual}
        listicle_sorting_type={element.listicle_type}
        listicle_sorting_direction={element.listicle_sorting}
        items={element.items}
        itemData={ExtraData}
        query=""
        dataSet={element.dataSet ?? []}
        provider_filter={element.provider_filter}
        searchterm={element.searchterm}
      />
    </div>
  );
}
